import React from "react";
import { Link } from "react-router-dom";
import { StudentUIType } from "./types/promotionResponse";

interface PromotionModalsProps {
  studentToPromote?: StudentUIType;
  toStageName?: string;
  fromStageName?: string;
  selectedCount?: number;
  isPromoting?: boolean;
  isPromotingBulk?: boolean;
  onPromote?: () => void;
  onPromoteBulk?: () => void;
  showPromoteModal?: boolean;
  setShowPromoteModal?: (show: boolean) => void;
  showBulkPromoteModal?: boolean;
  setShowBulkPromoteModal?: (show: boolean) => void;
}

const PromotionModals: React.FC<PromotionModalsProps> = ({
  studentToPromote,
  toStageName,
  fromStageName,
  selectedCount = 0,
  isPromoting = false,
  isPromotingBulk = false,
  onPromote,
  onPromoteBulk,
  showPromoteModal = false,
  setShowPromoteModal,
  showBulkPromoteModal = false,
  setShowBulkPromoteModal,
}) => {
  return (
    <>
      {/* Single Student Promotion Modal */}
      {showPromoteModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          id="promote-modal"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (onPromote) onPromote();
                }}
              >
                <div className="modal-body text-center">
                  <span className="promotion-icon">
                    <i
                      className="ti ti-arrow-up fs-24"
                      style={{ fontSize: "4rem", color: "#0d6efd" }}
                    />
                  </span>
                  <h4 className="mb-3 fw-semibold">
                    Confirm Student Promotion
                  </h4>
                  <p className="mb-4">
                    Are you sure you want to promote{" "}
                    <strong className="text-primary">
                      {studentToPromote?.name}
                    </strong>{" "}
                    from <strong>{studentToPromote?.stageName}</strong> to{" "}
                    <strong className="text-success">{toStageName}</strong>?
                    <br />
                    <small className="text-danger">
                      This action cannot be undone.
                    </small>
                  </p>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      onClick={() => setShowPromoteModal?.(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isPromoting}
                    >
                      {isPromoting ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                          ></span>
                          Promoting...
                        </>
                      ) : (
                        "Yes, Promote"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* /Single Student Promotion Modal */}

      {/* Bulk Promotion Modal */}
      {showBulkPromoteModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          id="bulk-promote-modal"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (onPromoteBulk) onPromoteBulk();
                }}
              >
                <div className="modal-body text-center">
                  <span className="promotion-icon">
                    <i
                      className="ti ti-users fs-24"
                      style={{ fontSize: "4rem", color: "#0d6efd" }}
                    />
                  </span>
                  <h4 className="mb-3 fw-semibold">Confirm Bulk Promotion</h4>
                  <p className="mb-4">
                    Are you sure you want to promote{" "}
                    <strong className="text-primary">
                      {selectedCount} students
                    </strong>{" "}
                    from <strong>{fromStageName}</strong> to{" "}
                    <strong className="text-success">{toStageName}</strong>?
                    <br />
                    <small className="text-danger">
                      This action cannot be undone.
                    </small>
                  </p>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      onClick={() => setShowBulkPromoteModal?.(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isPromotingBulk}
                    >
                      {isPromotingBulk ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                          ></span>
                          Promoting...
                        </>
                      ) : (
                        "Yes, Promote All"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* /Bulk Promotion Modal */}

      {/* Add modal backdrop when any modal is shown */}
      {(showPromoteModal || showBulkPromoteModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
};

export default PromotionModals;
